import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ItemDataService } from '../../services/item-data.service';
import { assetBaseUrl, poe1 } from '../../../game';
import { EconomyService } from '../../services/economy.service';
import { PricedItem, PriceType } from '../../models/economy-models';

@Component({
  selector: '[app-value]',
  imports: [],
  templateUrl: './value.component.html',
  styleUrl: './value.component.scss',
  host: {
    '[class.subtle]': 'subtle'
  }
})
export class ValueComponent implements OnInit, OnChanges {
  @Input() baseType?: string;
  @Input() unique?: boolean;
  @Input() value?: PricedItem;
  @Input() round?: number;
  @Input() rtl?: boolean;
  @Input() showPreviousValue?: boolean;
  @Input() manualTier?: boolean;
  @Input() favouriteCurrencyAdjusted?: boolean;
  @Input() hideExtraInfo?: boolean;
  @Input() forceRefresh?: any;
  @Input() subtle?: boolean;

  valueRounded?: number;
  divineValueRounded?: number;
  newValue?: boolean;
  usingPreviousValue?: boolean;
  manualValue?: boolean;
  extraInfoText?: string;

  previousValueRounded?: number;
  previousDivineValueRounded?: number;

  basicImage = assetBaseUrl + (poe1 ? '/poe1/img/currency/currencyrerollrare.webp' : '/img/currency/currencyaddmodtorare.webp');
  divineImage = assetBaseUrl + (poe1 ? '/poe1/img/currency/currencymodvalues.webp' : '/img/currency/currencymodvalues.webp');

  constructor(private itemDataService: ItemDataService, private economyService: EconomyService) {}

  ngOnInit(): void {
    this.updateValues();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.baseType !== undefined || this.value !== undefined) {
      this.updateValues();
    } else if (changes['manualTier'] || changes['favouriteCurrencyAdjusted']) {
      this.updateExtraInfoText();
    }
  }

  updateValues(): void {
    if (!this.baseType && !this.value) return;

    const valueToShow = this.value || (this.unique ? this.economyService.getUniqueValue(this.baseType!) : this.economyService.getCurrencyValue(this.baseType!));
    this.valueRounded = this.roundIfNeeded(valueToShow?.price);

    if (valueToShow) {
      const divValue = this.economyService.getCurrencyValue('Divine Orb')!;
      if (valueToShow.price && divValue.price && valueToShow.price > divValue.price * 1.5) {
        this.divineValueRounded = this.roundIfNeeded(parseFloat((valueToShow.price / divValue.price).toFixed(2)));
      } else {
        this.divineValueRounded = undefined;
      }
    }

    this.newValue = valueToShow?.type === PriceType.NewValue;
    this.usingPreviousValue = valueToShow?.type === PriceType.NoRecentValue;
    this.manualValue = valueToShow?.type === PriceType.Manual;
    this.updateExtraInfoText();

    if (this.showPreviousValue) {
      const previousValueToShow = this.unique ? this.economyService.getPreviousUniqueValue(this.baseType!) : this.economyService.getPreviousCurrencyValue(this.baseType!);
      if (previousValueToShow) {
        this.previousValueRounded = this.roundIfNeeded(previousValueToShow.price);

        const divValue = this.economyService.getPreviousCurrencyValue('Divine Orb')!;
        if (previousValueToShow.price && divValue.price && this.divineValueRounded) {
          this.previousDivineValueRounded = this.roundIfNeeded(parseFloat((previousValueToShow.price / divValue.price).toFixed(2)));
        } else {
          this.previousDivineValueRounded = undefined;
        }
      }
    }
  }

  private updateExtraInfoText(): void {
    const labels: string[] = [];
    if (this.manualValue) labels.push('fixed');
    else if (this.usingPreviousValue) labels.push('previous');
    else if (this.newValue) labels.push('new');
    if (this.manualTier) labels.push('minimum tier');
    if (this.favouriteCurrencyAdjusted) labels.push('favourite');
    this.extraInfoText = labels.length > 0 ? labels.join(', ') : undefined;
  }

  roundIfNeeded(value: number | undefined): number | undefined {
    if (!value) return value;

    if (this.round) {
      return parseFloat(value.toFixed(this.round));
    } else {
      return value;
    }
  }
}
